import type {Owner} from '../api/common-contracts'
import {getInitialState} from './initial-state'

/**
 * The owner type that this project's issue fields resolve through.
 *
 * Issue fields read identically for both owner types once loaded. Their settings links differ
 * because personal settings do not include the owner's login in the path.
 *
 * Falls back to `'organization'` when the owner is unexpectedly absent, so copy on organization
 * owned projects is never affected by a missing payload.
 */
export function getIssueFieldsOwnerType(): Owner['type'] {
  const {projectOwner} = getInitialState()

  return projectOwner?.type ?? 'organization'
}

export function getIssueFieldsSettingsHref(owner: Owner | undefined, issueFieldId?: number): string | undefined {
  if (!owner) return undefined

  const settingsPath =
    owner.type === 'user' ? '/settings/issue-fields' : `/organizations/${owner.login}/settings/issue-fields`

  return issueFieldId === undefined ? settingsPath : `${settingsPath}/${issueFieldId}`
}

export function getEditableIssueFieldSettingsHref(
  owner: Owner | undefined,
  viewerId: number | undefined,
  issueFieldId: number | undefined,
): string | undefined {
  if (owner?.type !== 'user' || owner.id !== viewerId || issueFieldId === undefined) return undefined

  return getIssueFieldsSettingsHref(owner, issueFieldId)
}
